import { render } from "./DeleteGoalPrompt.vue?vue&type=template&id=0cf21d8c&scoped=true"
import script from "./DeleteGoalPrompt.vue?vue&type=script&lang=js"
export * from "./DeleteGoalPrompt.vue?vue&type=script&lang=js"

import "./DeleteGoalPrompt.vue?vue&type=style&index=0&id=0cf21d8c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0cf21d8c"

export default script